import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectExternalProviderDashboardRetrieval = createSelector(
  [(state: AppState) => state.externalProvider.dashboardRetrieval],
  state => state,
);
